<template>
  <div 
    v-if="settingsStore.settings.show_beta_tag === '1'" 
    class="bg-primary-500 text-white py-1 px-3 sm:px-4 text-center text-[10px] sm:text-xs font-semibold tracking-wider uppercase z-50 relative"
  >
    <div class="container mx-auto flex items-center justify-center space-x-1 sm:space-x-2">
      <span class="bg-white text-primary-500 px-1 sm:px-1.5 py-0.5 rounded text-[8px] sm:text-[10px] font-bold shrink-0">BETA</span>
      <span>
        <span class="hidden sm:inline">This is a beta version of {{ settingsStore.settings.company_name || 'Ruxzom' }}. We're still improving things!</span>
        <span class="sm:hidden">Beta Version</span>
      </span>
    </div>
  </div>
</template>

<script setup>
import { useSettingsStore } from '@/stores/settings'

const settingsStore = useSettingsStore()
</script>
